import { selectAllQueries } from "@store/slices/archiveSlice";
import useStore from "@store/store";
import { useEffect, useMemo, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";

const Copy = ({ text }: { text: string }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let intervalId: NodeJS.Timer; 
    if (copied) {
      intervalId = setInterval(() => {
        setCopied(false);
      }, 1000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [copied]);

  return (
    <CopyToClipboard text={text} onCopy={() => setCopied(true)}>
      <button
        type="button"
        className={`flex items-center gap-2 p-2 mt-3 border rounded-xl ${
          copied ? "bg-green-300" : "bg-white"
        }`}
      >
        {copied ? (
          <>
            <span className="material-icons">done</span>
          </>
        ) : (
          <>
            <span className="material-icons">content_copy</span>
          </>
        )}{" "}
      </button>
    </CopyToClipboard>
  );
};

const ArchiveTable = () => {
  const queries = useStore(selectAllQueries);
  const queriesSorted = useMemo(
    () =>
      [...queries].sort(
        (a, b) => (a.createdAt as any).seconds - (b.createdAt as any).seconds
      ),
    [queries]
  );

  return (
    <div className="w-full h-full">
      {!queries || queries.length === 0 ? (
        <div className="w-full h-full flex justify-center items-center">
          <p>No Queries generated, yet!</p>
        </div>
      ) : (
        <div className="w-[90%] rounded-xl border-2 mx-auto relative overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-700 bg-gray-200">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Prompt
                </th>
                <th scope="col" className="px-6 py-3">
                  Response
                </th>
                <th scope="col" className="px-6 py-3">
                  Type
                </th>
                <th scope="col" className="px-6 py-3">
                  Copy
                </th>
              </tr>
            </thead>
            <tbody>
              {queriesSorted.map((query, i) => (
                <tr key={i} className="bg-white border-b">
                  <th scope="row" className="px-6 py-4 font-medium">
                    {query.prompt}
                  </th>
                  <td className="px-6 py-4">{query.response}</td>
                  <td className="px-6 py-4">{query.type}</td>
                  <td className="px-6 py-4">
                    <Copy text={query.response} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ArchiveTable;
